import { HelpMessage } from 'utils/constants'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'

export const CreateEditFormItems: React.FC = () => {
  return (
    <>
      <NameFormItem help={HelpMessage.CAS.Types.Name} />
      <DescriptionFormItem entityName="Type" />
    </>
  )
}
